// eslint-disable-next-line
export const CHANGE_SELECTED_PORTFOLIO_TABLE = 'PORTFOLIO/CHANGE_SELECTED_PORTFOLIO_TABLE';
